<template>
  <v-app class="app-background">
   <keep-alive max="5">
     <router-view/>
   </keep-alive>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
  }
</script>
<style>
@import "assets/css/font.css";
@import "assets/css/app.css";
 ::-webkit-scrollbar {
    width: 10px;
}
  .v-navigation-drawer__content::-webkit-scrollbar{
   width: 0 !important;
}
::-webkit-scrollbar-track {
    background-color: darkgrey;
}

::-webkit-scrollbar-thumb {
    /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
        background-image: linear-gradient(180deg, #16293F  0%, #708AD4 99%);
    box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
    border-radius: 100px;
}
@media screen and (min-width: 980px) {

}

</style>
